import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Divider } from '@material-ui/core';
import Benefit from './Benefit';
import BenefitsTitle from './BenefitsTitle';
import IconMapper from '../../../../../helpers/IconMapper';
import GoldBenefitsModal from './GoldBenefitsModal';
import BenefitsFooter from './BenefitsFooter';
import { useBenefitsListStyles } from './styles';

const BenefitsList = ({ ...props }) => {
  const {
    benefits,
    type,
    mobile,
    image,
    onClick,
    open,
    onClose,
    points,
  } = props;
  const classes = useBenefitsListStyles();

  return (
    <Grid container>
      <Grid item xs={12}>
        <BenefitsTitle
          image={image}
          mobile={mobile}
          type={type}
          onClick={() => onClick()}
          points={points}
        />
      </Grid>
      {Object.entries(benefits).length > 0 &&
        benefits[`${type.toLowerCase()}`].map((benefit, index) => (
          <Benefit
            key={index}
            icon={IconMapper.get(benefit.title)}
            title={benefit.title}
            description={benefit.description}
          />
        ))}
      <Grid item xs={12}>
        <Divider className={classes.divider} />
        <BenefitsFooter mobile={mobile} />
      </Grid>
      <GoldBenefitsModal
        benefits={benefits}
        type={type}
        open={open}
        onClose={onClose}
      />
    </Grid>
  );
};

BenefitsList.propTypes = {
  benefits: PropTypes.object,
  type: PropTypes.string,
  mobile: PropTypes.bool,
  image: PropTypes.string,
  onClick: PropTypes.func,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  points: PropTypes.number,
};

export default BenefitsList;
